<mat-dialog-content>
  <p>
    {{'cookiePolicy' | translate}}
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="true" >{{'allowAll' | translate}}</button>
<!--  <button mat-button [mat-dialog-close]="false" >{{'blockAll' | translate}}</button>-->
</mat-dialog-actions>
